module.exports = __webpack_public_path__ + "media/icons/paliwo-title@2x-f879562d.png";